import { createAction, handleActions } from 'redux-actions'

const setSubValuations = createAction('SCREENS/SUB_VALUATIONS/SET_SUB_VALUATIONS')
const resetSubValuations = createAction('SCREENS/SUB_VALUATIONS/RESET_SUB_VALUATIONS')

const defaultState = []

const reducer = handleActions(
  {
    [setSubValuations]: (state, { payload }) => payload,
    [resetSubValuations]: () => [],
  },
  defaultState,
)

export { setSubValuations, resetSubValuations, reducer }
